import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import FormatarDataLonga from "utils/formatarDataLonga";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export interface useTarefasLeadV2Interface {
  idLead: string | "";
  idsTiposTarefa?: string[] | null;
  InicioIntervaloCadastroTarefa?: string | null;
  FimIntervaloCadastroTarefa?: string | null;
  StatusTarefa?: 1 | 2 | 3 | null;
  DataProgramadaRealizacaoTarefa?: any;
}

export interface TaskData {
  quantidadeTarefaConcluidas: number;
  quantidadeTarefaEmAberto: number;
  quantidadeTarefasAtrasadas: number;
  tarefas: TaskInterface[];
}

export interface TaskInterface {
  anexo: any;
  idTarefaLead: string;
  titulo: string;
  codigoSequencial: number;
  tipoTarefa: string;
  idEmpreendimento: string;
  empreendimento: string;
  idLead: string;
  idLeadCorretor: string;
  nomeLead: string;
  telefonePrincipal: string;
  emailPrincipal: string;
  idTipoTarefa: string;
  idPdv: string;
  nomePdv: string;
  descricao: string;
  dataHoraProgramadaRealizacaoTarefa: string;
  dataHoraConclusaoTarefa: string;
  codigoStatusTarefa: 1 | 2 | 3;
  descricaoStatusTarefa: string;
  descricaoEtapaFunilLead: string;
  urlAnexo: string;
  tipoResultadoTarefa: string;
  observacao: string;
  tarefaInseridaOutlook: boolean;
  idTipoResultadoTarefa: string;
  tarefaLeadRegionalSul: boolean;
  presencaEspecialista: boolean;
  tipoDeAgendamentoVisita: number;
  idEmpreendimentoRegionalSul: string;
  empreendimentoRegionalSul: string;
  localRegionalSul: string;
  idEtapaFunilLead: string;
  idCorretor: string;
  nomeCorretor: string;
  idCorretorAtendimento: string;
  nomeCorretorAtendimento: string;
}

export function useTarefasLeadV2(
  props: useTarefasLeadV2Interface & QueryGlobalInterface
) {
  const mapIdTiposTarefas = props.idsTiposTarefa
    ?.map((item: string) => `&idsTiposTarefa=${item}`)
    .join("");

  const fetchData = async () => {
    const BUSCAR_LEAD = `${leadsWebEnviroment}/common/tarefas-leads/lead/v2/${
      props.idLead
    }?${mapIdTiposTarefas}${
      props.InicioIntervaloCadastroTarefa
        ? `&InicioIntervaloCadastroTarefa=${
            FormatarDataLonga(props.InicioIntervaloCadastroTarefa) || null
          }`
        : ""
    }${
      props.FimIntervaloCadastroTarefa
        ? `&FimIntervaloCadastroTarefa=${
            FormatarDataLonga(props.FimIntervaloCadastroTarefa) || null
          }`
        : ""
    }&StatusTarefa=${props.StatusTarefa || 1}${
      props.DataProgramadaRealizacaoTarefa
        ? `&DataProgramadaRealizacaoTarefa=${props.DataProgramadaRealizacaoTarefa}`
        : ""
    }`;
    const response = await instance.get(BUSCAR_LEAD);
    const dataWithPagination = {
      data: response?.data?.data as TaskData,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar tarefas. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
